module.exports = __webpack_public_path__ + "img/148.5137f7bd.jpg";